import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Assets/Table";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
    Bg,
    BoxContainer,
    Underline,
} from "../../Components/Styles/PageStyles";
import {
    FieldWrapper,
    InputGroup,
    Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import BaseForm from "../../Components/Assets/BaseForm";
import EditBasicDetails from "../../Components/Assets/EditDetails/EditBasicDetails";
import EditPurchaseDetails from "../../Components/Assets/EditDetails/EditPurchaseDetails";
import EditAssignmentDetails from "../../Components/Assets/EditDetails/EditAssignmentDetails";
import EditMaintenanceWarranty from "../../Components/Assets/EditDetails/EditMaintenanceDetails";
import EditDocuments from "../../Components/Assets/EditDetails/EditDocuments";
import ViewDetails from "../../Components/Assets/ViewDetails";
import MaintenanceDetails from "../../Components/Assets/ViewMaintenanceDetails";
import ViewDocuments from "../../Components/Assets/ViewDocuments";
import Testing from "../../Components/Assets/Testing";
import ViewDetailsTest from "../../Components/Assets/ViewDetailTest";
import ViewExpenseTest from "../../Components/Assets/ViewExpenseTest";


const  Assets = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [fetchData, setFetchData] = useState([]);
    const [filterValue, setFilterValue] = useState("");
    const [filter, setFilter] = useState("mobile");
    const [editAsset, setEditAsset] = useState(false);
    const [editBasicAsset, setEditBasicAsset] = useState(false);
    const [editPurchaseDetails, setEditPurchaseDetails] = useState(false);
    const [editAssignmentDetails, setEditAssignmentDetails] = useState(false);
    const [editMaintenanceDetails, setEditMaintenanceDetails] = useState(false);
    const [viewMaintenanceDetail, setViewMaintenanceDetail] = useState(false);
    const [viewDocuments, setViewDocuments] = useState(false);
    const [editDocuments, setEditDocuments] = useState(false);
    const [uploadLogo, setUploadLogo] = useState(false);
    const [addCharges, setAddCharges] = useState(false);
    const [viewDetail, setViewDetail] = useState(false);
    const [viewTesting ,setViewTesting] = useState(false);
    const [isAddAssetModal, setIsAddAssetModal] = useState(false);
    const [formData, setFormData] = useState({
        basicDetails: {}, 
        purchaseDetails: {}, 
        assignmentDetails: {}, 
        maintenanceWarranty: {}, 
        supportingDocument: {}, 
    });

    const [type, setType] = useState(1);
    const [startDate, setStartDate] = useState(
        moment(new Date()).subtract(360, "days").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment(new Date()).format("YYYY-MM-DD")
    );
    const { t, i18n } = useTranslation();

    const initialValues = {
        name: "",
        filterVal: filterValue,
        startDate: moment(new Date()).subtract(360, "days").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
    };

    const fetchFunction = async () => {
        const body = new FormData();
        body.append("filterType", filter);
        body.append("filterValue", filterValue);
        body.append("startDate", startDate);
        body.append("endDate", endDate);
        body.append("type", type);
        return await axios.post(`${Config.apiUrl}/getowners`, body, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const getOwnersSuccess = (res) => {
        if (res.data.status == "NOK" || res.data.data == false) {
            error = true;
        } else setFetchData(res.data.data);
    };

    const getOwnersError = (res) => { };

    const {
        isLoading: isLoading,
        mutate: getOwnersMutate,
        error,
        data,
        isRefetching,
        refetch,
    } = useMutation(fetchFunction, {
        onSuccess: getOwnersSuccess,
        onError: getOwnersError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getOwnersMutate();
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filterValue, startDate, endDate]);

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setStartDate(newValues.startDate);
        setEndDate(newValues.endDate);
        getOwnersMutate();
    };
    const ChangeHandler = (e) => {
        setFilterValue(e.target.value);
    };

    //------- Edit Single Entry -------
    const EditAssetFunction = async (values) => {
        console.log("edit asset values received ", values);
        const body = new FormData();
        body.append("quantity", values.quantity);
        body.append("property", values.assignedProperty);
        body.append("currentStatus", values.currentStatus);
        body.append("depreciation", values.depreciation);
        body.append("description", values.description);
        body.append("maintenanceDate", values.maintenanceDate);
        body.append("scheduleMaintenanceDate", values.scheduleMaintenanceDate);
        return await axios.post(`${Config.apiUrl}/editasset`, body, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };
    const onEditEntrySuccess = (data) => {
        if (data?.data?.status == "OK") {
            toast.success(data?.data?.msg || "Success");
            // getOwnersMutate();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
        setSelectedData("");
        setEditAsset(false);
        setFetchData(data?.data?.data);
    };
    const onEditEntryError = (data) => {
        setSelectedData("");
        setEditAsset(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };
    const { isLoading: editEntryLoading, mutate: editAssetMutate } = useMutation(
        EditAssetFunction,
        {
            onSuccess: onEditEntrySuccess,
            onError: onEditEntryError,
        }
    );
    // Add Asset Function
    const addAssetFunction = async (values) => {
        const body = new FormData();
        body.append("type", values.basicDetails.assetType);
        body.append("name", values.basicDetails.assetSubType);
        body.append("count", values.basicDetails.quantity);
        body.append("purchaseDate", values.purchaseDetails.purchaseDate);
        body.append("cost", values.purchaseDetails.purchasePrice);
        body.append("status", values.assignmentDetails.currentStatus);
        body.append("lastMaintenance", values.maintenanceWarranty.maintenanceDate);
        body.append("nextMaintenance", values.maintenanceWarranty.scheduleMaintenanceDate);
        body.append("description", values.maintenanceWarranty.notes);

        return await axios.post(`${Config.apiUrl}/addasset`, body, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const addAssetFunctionSuccess = (data) => {
        if (data?.data?.status === "OK") {
            toast.success(data?.data?.msg || "Asset data successfully successfully Updated.");
        }
    };

    const addAssetFunctionError = (res) => { };

    const {
        isLoading: isaddAssetLoading,
        mutate: addAssetFunctionMutate,
    } = useMutation(addAssetFunction, {
        onSuccess: addAssetFunctionSuccess,
        onError: addAssetFunctionError,
    });

    return (
        <>
            <Bg
                style={{
                    backgroundImage: `url(${Images.BeamsBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "top left",
                    height: "100vh",
                }}
            >
                <Navbar />

                {/* <Page> */}
                <BoxContainer>
                    <div className="flex w-full justify-between items-center">
                        <div>
                            <Title>{t("Assets")}</Title>
                            <Underline />
                        </div>
                    </div>
                    <UploadWrapper>
                        <Button type="button" onClick={() => setIsAddAssetModal(true)}>
                            <p className="text-sm">{"Add Assets"}</p>
                        </Button>
                    </UploadWrapper>

                    <div className="flex w-full justify-between items-center">
                        <Filters
                            submitHandler={submitHandler}
                            initialValues={initialValues}
                            InitialLoading={isLoading}
                            setFilter={setFilter}
                            setFilterValue={setFilterValue}
                            ChangeHandler={ChangeHandler}
                            filterValue={filterValue}
                            filter={filter}
                            user={user}
                            t={t}
                        />
                    </div>

                    {/* Add Assets Modal */}
                    <div
                        className={`${isAddAssetModal ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setIsAddAssetModal(null)}
                    />
                    <div
                        className={`${isAddAssetModal
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {isAddAssetModal && (
                            <BaseForm
                                setIsAddDuesModal={setIsAddAssetModal}
                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading}
                                setFormData={setFormData}
                                formData={formData}
                            />
                        )}
                    </div>



                    {/* Edit Basic Asset Modal */}
                    <div
                        className={`${editBasicAsset ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setEditBasicAsset(null)}
                    />
                    <div
                        className={`${editBasicAsset
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {editBasicAsset && (
                            <EditBasicDetails setEditBasicAsset={setEditBasicAsset}
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                setViewDetail={setViewDetail}
                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading} />

                        )}
                    </div>
                    {/* Edit Purchase and Financial Asset Modal */}
                    <div
                        className={`${editPurchaseDetails ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setEditPurchaseDetails(null)}
                    />
                    <div
                        className={`${editPurchaseDetails
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {editPurchaseDetails && (
                            <EditPurchaseDetails setEditPurchaseDetails={setEditPurchaseDetails}
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                setViewDetail={setViewDetail}

                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading} />

                        )}
                    </div>

                    {/* Edit Assignment Details Asset Modal */}
                    <div
                        className={`${editAssignmentDetails ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setEditAssignmentDetails(null)}
                    />
                    <div
                        className={`${editAssignmentDetails
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {editAssignmentDetails && (
                            <EditAssignmentDetails setEditAssignmentDetails={setEditAssignmentDetails}
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                setViewDetail={setViewDetail}

                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading} />
                        )}
                    </div>

                    {/* Edit Maintenance & Warranty Details Asset Modal */}
                    <div
                        className={`${editMaintenanceDetails ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setEditMaintenanceDetails(null)}
                    />
                    <div
                        className={`${editMaintenanceDetails
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {editMaintenanceDetails && (
                            <EditMaintenanceWarranty setEditMaintenanceDetails={setEditMaintenanceDetails}
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading} />
                        )}
                    </div>

                    {/* Edit Document Details Asset Modal */}
                    <div
                        className={`${editDocuments ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setEditDocuments(null)}
                    />
                    <div
                        className={`${editDocuments
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {editDocuments && (
                            <EditDocuments setEditDocuments={setEditDocuments}
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                addAssetFunctionMutate={addAssetFunctionMutate}
                                isaddAssetLoading={isaddAssetLoading} />
                        )}
                    </div>



                    {/* {viewDetail && (
                        <ViewDetailModel
                            setViewDetail={setViewDetail}
                            // selectedData={selectedData}
                            setSelectedData={setSelectedData}
                            setUploadLogo={setUploadLogo}
                        />
                    )} */}


                    <div
                        className={`${viewDetail ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setViewDetail(null)}
                    />
                    <div
                        className={`${viewDetail
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {/* {viewDetail && (
                            <ViewDetails
                                setViewDetail={setViewDetail}
                                // selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                setUploadLogo={setUploadLogo}
                                setEditBasicAsset={setEditBasicAsset}
                                setEditPurchaseDetails={setEditPurchaseDetails}
                                setEditAssignmentDetails={setEditAssignmentDetails}

                            />
                        )} */}
                        {viewDetail && (
                            <ViewExpenseTest
                                setViewDetail={setViewDetail}
                                // selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                setUploadLogo={setUploadLogo}
                                setEditBasicAsset={setEditBasicAsset}
                                setEditPurchaseDetails={setEditPurchaseDetails}
                                setEditAssignmentDetails={setEditAssignmentDetails}
                                setEditMaintenanceDetails={setEditMaintenanceDetails}
                                setEditDocuments={setEditDocuments}
                            />
                        )}
                    </div>


                    {/* Maintenance Details View Modal */}
                    <div
                        className={`${viewMaintenanceDetail ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setViewMaintenanceDetail(null)}
                    />
                    <div
                        className={`${viewMaintenanceDetail
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {viewMaintenanceDetail && (
                            <MaintenanceDetails
                                setViewMaintenanceDetail={setViewMaintenanceDetail}
                                // selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                setUploadLogo={setUploadLogo}
                                setEditMaintenanceDetails={setEditMaintenanceDetails}
                            />
                        )}
                    </div>

                    {/* Documents Details View Modal */}
                    <div
                        className={`${viewDocuments ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setViewDocuments(null)}
                    />
                    <div
                        className={`${viewDocuments
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {viewDocuments && (
                            <ViewDocuments
                                setViewDocuments={setViewDocuments}
                                // selectedData={selectedData}
                                setSelectedData={setSelectedData}
                                setUploadLogo={setUploadLogo}
                            />
                        )}
                    </div>
                    {/* Modal for testing Purpose  */}
                    <div
                        className={`${viewTesting ? "flex" : "hidden"
                            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
                        onClick={() => setViewTesting(null)}
                    />
                    <div
                        className={`${viewTesting
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
                    >
                        {viewTesting && (
                            <Testing 
                                // setSelectedForm={setSelectedForm} 
                                // onClose={onClose} 
                                setViewTesting={setViewTesting}
                                // addAssetFunctionMutate={addAssetFunctionMutate}
                                // isaddAssetLoading={isaddAssetLoading}
                                 />

                        )}
                    </div>

                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                ApiData={fetchData || []}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                setEditAsset={setEditAsset}
                                setEditBasicAsset={setEditBasicAsset}
                                setEditPurchaseDetails={setEditPurchaseDetails}
                                setEditAssignmentDetails={setEditAssignmentDetails}
                                setEditMaintenanceDetails={setEditMaintenanceDetails}
                                setViewMaintenanceDetail={setViewMaintenanceDetail}
                                setEditDocuments={setEditDocuments}
                                setViewDetail={setViewDetail}
                                setViewDocuments={setViewDocuments}
                                userType={user.userType}
                                setAddCharges={setAddCharges}
                                setUploadLogo={setUploadLogo}
                                setViewTesting={setViewTesting}
                            />
                            {(error || data?.data?.msg == "No data found") && !isLoading && (
                                <NotFoundModel />
                            )}
                        </TableWrapper>
                    )}
                    {(isLoading || isRefetching) && <Loading />}
                </BoxContainer>
            </Bg>
        </>
    );
};

const Filters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    user,
    filter,
    setFilter,
    setFilterValue,
    filterValue,
    ChangeHandler,
    t,
}) => {
    const today = moment().format("YYYY-MM-DD");
    return (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
            <Form className="w-full">
                <FilterContainer>
                    <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
                        <div className="flex items-end gap-2">
                            <InputGroup className="max-w-[200px]">
                                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                                <FieldWrapper className="h-10">
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-3.5"
                                    />
                                    <Field
                                        type="date"
                                        name="startDate"
                                        id="startDate"
                                        className="ml-1"
                                        max={today}
                                    />
                                </FieldWrapper>
                            </InputGroup>

                            <InputGroup className="max-w-[130px]">
                                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                                <FieldWrapper className="h-10">
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-3.5"
                                    />
                                    <Field
                                        type="date"
                                        name="endDate"
                                        id="endDate"
                                        className="ml-1"
                                        max={today}
                                    />
                                </FieldWrapper>
                            </InputGroup>
                        </div>
                        <ApplyBtn disabled={InitialLoading} type="submit">
                            {t("Date_filter")}
                        </ApplyBtn>
                    </div>

                    <div className="flex gap-4 items-end">
                        {filter !== "status" && filter !== "paystatus" ? (
                            <InputGroup className="max-w-[200px]">
                                <Label htmlFor="filterVal">{("")}</Label>
                                <Field
                                    className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2 ml-1"
                                    placeholder="Search..."
                                    type="text"
                                    name="filterVal"
                                    id="filterVal"
                                    inputMode={filter === "mobile" ? "numeric" : "text"}
                                    maxLength={filter === "mobile" ? "10" : undefined}
                                    pattern={filter === "mobile" ? "[0-9]*" : undefined}
                                    value={filterValue}
                                    onChange={(e) => {
                                        if (filter === "mobile") {
                                            const value = e.target.value;
                                            // Restrict input to digits only, up to 10 characters
                                            if (/^\d{0,10}$/.test(value)) {
                                                ChangeHandler(e);
                                            }
                                        } else {
                                            ChangeHandler(e);
                                        }
                                    }}
                                />
                            </InputGroup>
                        ) : filter === "status" ? (
                            <InputGroup
                                className="min-w-[120px]"
                                style={{ flexBasis: "content" }}
                            >
                                <Label htmlFor="filter">{t("Select")}</Label>
                                <Select
                                    autoComplete="off"
                                    className="px-2 bg-transparent text-sm border-none"
                                    style={{ height: "40px" }}
                                    value={filterValue}
                                    onChange={ChangeHandler}
                                >
                                    <MenuItem value="" disabled>
                                        {t("Select Status")}
                                    </MenuItem>
                                    <MenuItem value="3">{t("Active")}</MenuItem>
                                    <MenuItem value="4">{t("Enrolled")}</MenuItem>
                                </Select>
                            </InputGroup>
                        ) : null}

                        <InputGroup
                            className="min-w-[120px]"
                            style={{ flexBasis: "content" }}
                        >
                            <Label htmlFor="filter">{t("Search By")}</Label>

                            <Select
                                autoComplete="off"
                                className="w-24 px-2 bg-transparent text-sm border-none"
                                style={{ height: "40px" }}
                                value={filter}
                                onChange={(e) => {
                                    setFilter(e.target.value);
                                    setFilterValue("");
                                }}
                            >
                                <MenuItem value="mobile">Phone</MenuItem>
                                <MenuItem value="name">Name</MenuItem>
                                <MenuItem value="status">Status</MenuItem>
                                {user.userType !== Config.userType.OPERATION && (
                                    <MenuItem value="city">City</MenuItem>
                                )}
                            </Select>
                        </InputGroup>
                    </div>
                </FilterContainer>
            </Form>
        </Formik>
    );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
const UploadWrapper = tw.div`flex items-center gap-3 `;
const Button = tw.button`
 text-white bg-primary-color transition hover:bg-sky-700  flex items-center !ml-auto space-x-1 justify-center w-40   h-10 text-xs  whitespace-nowrap rounded px-6
`;
export default Assets;
